/* Cookie consent */
(function () {
    $(function () {
        var $cookieConsent = $("[data-cookie-consent]");

        $cookieConsent.find('[data-cookie-consent="accept"]').click(function (event) {
            event.preventDefault();

            accept();
        });

        $cookieConsent.find('[data-cookie-consent="deny"]').click(function (event) {
            event.preventDefault();

            deny();
        });

        $cookieConsent.find('[data-cookie-consent="close"]').click(function (event) {
            event.preventDefault();

            close();
        });
    });

    function accept()
    {
        respond(true);
    }

    function deny()
    {
        respond(false);
    }

    function close()
    {
        $("[data-cookie-consent]").remove();
    }

    function respond(value)
    {
        $("[data-cookie-consent]").hide();

        cookieConsent.set(value)
            .then(function (data) {
                if (window.ga) {
                    ga("set", "anonymizeIp", !data.value);
                }

                if (data.reload) {
                    location.reload();
                    return;
                }

                $("[data-cookie-consent]").remove();
            })
            .catch(function (response) {
                $("[data-cookie-consent]").show();

                if (!response.responseJSON) {
                    // beAlert(response.statusText, "error");
                    return;
                }

                // beAlert(response.responseJSON.message, "error");
            });
    }
})();
